@if (active()) {
  <div class="fixed top-0 left-0 w-screen h-screen z-100">
    <div class="fixed top-[50%] left-[50%] -translate-[50%] z-100">
      <div class="w-12.5 rounded-full aspect-square loader"></div>
    </div>
  </div>
}
